import {useState} from "react";
import DashboardService from "../services/api/dashboard";

const useDashboard = () => {

    const [isFetchingTotalSuccessfulVerification, setFetchingTotalSuccessfulVerification] = useState(false);
    const [totalSuccessfulVerificationCount, setTotalSuccessfulVerificationCount] = useState(0);
    const [verificationCountStatusDateRange, setVerificationCountStatusDateRange] = useState(0);
    const [verificationCount, setVerificationCount] = useState(0);
    const [topVerificationProducts, setTopVerificationProducts] = useState(0);
    const [totalVerificationPerHour, setTotalVerificationPerHour] = useState([]);
    const [authenticationOverviewCount, setAuthenticationOverviewCount] = useState([]);
    const [authenticationStatus, setAuthenticationStatus] = useState([]);
    const [authenticationCount, setAuthenticationCount] = useState([]);
    const [totalAuthenticationPerHour, setTotalAuthenticationPerHour] = useState(0);
    const [topProductAnomalies, setTopProductAnomalies] = useState([]);
    const [topProductAnomalyDetection, setTopProductAnomalyDetection] = useState([]);
    const [geolocationDistributionData, setGeolocationDistributionData] = useState([]);
    const [verificationStatusGraphDateRange, setVerificationStatusGraphDateRange] = useState(0);
    const [isFetchingVerificationStatus, setFetchingVerificationStatus] = useState(false);
    const [isFetchingTopProductsAnomalies, setFetchingTopProductsAnomalies] = useState(false);
    const [isFetchingVerificationCount, setFetchingVerificationCount] = useState(false);
    const [isFetchingDashboardAuthenticationStatus, setFetchingDashboardAuthenticationStatus] = useState(false);
    const [isFetchingDashboardAuthenticationCount, setFetchingDashboardAuthenticationCount] = useState(false);
    const [isFetchingAnomalyDetection, setFetchingAnomalyDetection] = useState(false);
    const [isFetchingTopVerificationProducts, setFetchingTopVerificationProducts] = useState(false);
    const [isFetchingGeographicDistribution, setFetchingGeographicDistribution] = useState(false);
    const [isFetchPeakVerificationTimeAnalysis, setFetchPeakVerificationTimeAnalysis] = useState(false);
    const [verificationStatusGraph, setVerificationStatusGraph] = useState([]);
    const [isFetchingVerificationStatusGraph, setFetchingVerificationStatusGraph] = useState(false);
    const [dashboardOverviewCount, setDashboardOverviewCount] = useState(null);
    const [isFetchDashboardOverview, setFetchDashboardOverview] = useState(null);
    
    const getTotalVerification = () => {
        setFetchingTotalSuccessfulVerification(true);

        DashboardService.getTotalVerification().then((res) => {
            console.log("getTotalVerification data xxxx", res.data);
            
            if (res.data.success) {
                setFetchingTotalSuccessfulVerification(false);

                let api_result = res.data.data;
                setTotalSuccessfulVerificationCount(api_result.find(item => item.status === "Successful")?.count || 0);
            }

        }).catch((error) => {
            console.log("getTotalVerification error xxxx", error);

            setFetchingTotalSuccessfulVerification(false);
        })
    }
    
    const getTotalVerificationByDateRange = (startDate, endDate) => {
        DashboardService.getTotalVerificationByDateRange(startDate, endDate).then((res) => {
            console.log("getTotalVerificationByDateRange data xxxx", res.data);
            
            if (res.data.success) {
                setVerificationCountStatusDateRange(res.data.data);
            }

        }).catch((error) => {
            console.log("getTotalVerificationByDateRange error xxxx", error);
        })
    }

    const getTotalVerificationStatusGraphByDateRange = (startDate, endDate) => {
        setFetchingVerificationStatus(true);

        DashboardService.getTotalVerificationByDateRange(startDate, endDate).then((res) => {
            console.log("getTotalVerificationStatusGraphByDateRange data xxxx", res.data);
            
            if (res.data.success) {
                setVerificationStatusGraphDateRange(res.data.data);
                setFetchingVerificationStatus(false);
            }

        }).catch((error) => {
            console.log("getTotalVerificationStatusGraphByDateRange error xxxx", error);

            setFetchingVerificationStatus(false);
        })
    }

    const getVerificationCount = (startDate, endDate) => {
        setFetchingVerificationCount(true);

        DashboardService.getVerificationCount(startDate, endDate).then((res) => {
            console.log("getVerificationCount data xxxx", res.data);
            
            if (res.data.success) {
                setVerificationCount(res.data.data);
                setFetchingVerificationCount(false);
            }

        }).catch((error) => {
            console.log("getVerificationCount error xxxx", error);
            setFetchingVerificationCount(false);
        })
    }

    const getTopVerificationProducts = (startDate, endDate) => {
        setFetchingTopVerificationProducts(true);

        DashboardService.getTopVerificationProducts(startDate, endDate).then((res) => {
            console.log("getTopVerificationProducts data xxxx", res.data);
            
            if (res.data.success) {
                setTopVerificationProducts(res.data.data);
                setFetchingTopVerificationProducts(false);
            }

        }).catch((error) => {
            console.log("getTopVerificationProducts error xxxx", error);
            setFetchingTopVerificationProducts(false);
        })
    }

    const getTotalVerificationPerHour = (startDate, endDate) => {
        setFetchPeakVerificationTimeAnalysis(true);

        DashboardService.getTotalVerificationPerHour(startDate, endDate).then((res) => {
            console.log("getTotalVerificationPerHour data xxxx", res.data);
            if (res.data.success) {
                setTotalVerificationPerHour(res.data.data);
                setFetchPeakVerificationTimeAnalysis(false);
            }
        }).catch((error) => {
            console.log("getTopVerificationProducts error xxxx", error);
            setFetchPeakVerificationTimeAnalysis(false);
        })
    }

    const getDashboardTotalAuthenticationByStatus = () => {
        DashboardService.getDashboardTotalAuthenticationByStatus().then((res) => {
            console.log("getDashboardTotalAuthenticationByStatus data xxxx", res.data);
            
            if (res.data.success) {
                setAuthenticationOverviewCount(res.data.data);
            }

        }).catch((error) => {
            console.log("getDashboardTotalAuthenticationByStatus error xxxx", error);
        })
    }

    const getDashboardAuthenticationStatus = (startDate, endDate) => {
        setFetchingDashboardAuthenticationStatus(true);

        DashboardService.getDashboardAuthenticationStatus(startDate, endDate).then((res) => {
            console.log("getDashboardAuthenticationStatus data xxxx", res.data);
            
            if (res.data.success) {
                setAuthenticationStatus(res.data.data);
                setFetchingDashboardAuthenticationStatus(false);
            }

        }).catch((error) => {
            console.log("getDashboardAuthenticationStatus error xxxx", error);
            setFetchingDashboardAuthenticationStatus(false);
        })
    }

    const getDashboardAuthenticationCount = (startDate, endDate) => {
        setFetchingDashboardAuthenticationCount(true);

        DashboardService.getDashboardAuthenticationCount(startDate, endDate).then((res) => {
            console.log("getDashboardAuthenticationCount data xxxx", res.data);
            
            if (res.data.success) {
                setAuthenticationCount(res.data.data);
                setFetchingDashboardAuthenticationCount(false);
            }

        }).catch((error) => {
            console.log("getDashboardAuthenticationCount error xxxx", error);
            setFetchingDashboardAuthenticationCount(false);
        })
    }

    const getTotalAuthenticationPerHour = (startDate, endDate) => {
        DashboardService.getTotalAuthenticationPerHour(startDate, endDate).then((res) => {
            console.log("getTotalAuthenticationPerHour data xxxx", res.data);
            
            if (res.data.success) {
                setTotalAuthenticationPerHour(res.data.data);
            }

        }).catch((error) => {
            console.log("getTotalAuthenticationPerHour error xxxx", error);
        })
    }

    const getTopProductAnomalies = (startDate, endDate) => {
        setFetchingTopProductsAnomalies(true);

        let top = 5;

        DashboardService.getTopProductAnomalies(startDate, endDate, top).then((res) => {
            console.log("getTopProductAnomalies data xxxx", res.data);
            
            if (res.data.success) {
                setTopProductAnomalies(res.data.data);
                setFetchingTopProductsAnomalies(false);
            }

        }).catch((error) => {
            console.log("getTopProductAnomalies error xxxx", error);

            setFetchingTopProductsAnomalies(false);
        })
    }

    const getProductAnomalyDetection = (startDate, endDate) => {
        let top = 10;
        setFetchingAnomalyDetection(true);

        DashboardService.getProductAnomalyDetection(startDate, endDate, top).then((res) => {
            console.log("getProductAnomalyDetection data xxxx", res.data);
            
            if (res.data.success) {
                setTopProductAnomalyDetection(res.data.data);
                setFetchingAnomalyDetection(false);
            }

        }).catch((error) => {
            console.log("getProductAnomalyDetection error xxxx", error);
            setFetchingAnomalyDetection(false);
        })
    }

    const getGeolocationDistribution = (parameters) => {
        setFetchingGeographicDistribution(true);

        DashboardService.getGeolocationDistribution(parameters).then((res) => {
            console.log("getGeolocationDistribution data xxxx", res);
            
            if (res.data.success) {
                setGeolocationDistributionData(res.data.data);
                setFetchingGeographicDistribution(false);
            }

        }).catch((error) => {
            console.log("getGeolocationDistribution error xxxx", error);
            setFetchingGeographicDistribution(false);
        })
    }

    const getGeolocationDistributionFilterByCountry = (parameters) => {
        setFetchingGeographicDistribution(true);

        DashboardService.getGeolocationDistributionFilterByCountry(parameters).then((res) => {
            console.log("getGeolocationDistributionFilterByCountry data xxxx", res);
            
            if (res.data.success) {
                if (res.data.data.length > 0) {
                    const geolocationData = res.data.data; 
    
                    const updatedData = geolocationData.map((countryData) => ({
                        ...countryData,
                        region: countryData.region.map((region) => ({
                            ...region,
                            count: region.count, 
                        })),
                        count: countryData.region.reduce(
                            (sum, region) => sum + region.count,
                            0
                        ),
                    }));
    
                    setGeolocationDistributionData(updatedData);
                    setFetchingGeographicDistribution(false);

                } else {
                    setGeolocationDistributionData([]);
                    setFetchingGeographicDistribution(false);
                }
            }

        }).catch((error) => {
            console.log("getGeolocationDistributionFilterByCountry error xxxx", error);
            setFetchingGeographicDistribution(false);
        })
    }

    const getVerificationStatusGraph = (startDate, endDate) => {
        setFetchingVerificationStatusGraph(true);

        DashboardService.getVerificationStatusGraph(startDate, endDate).then((res) => {
            console.log("getVerificationStatusGraph data xxxx", res.data);
            
            if (res.data.success) {
                setVerificationStatusGraph(res.data.data);
                setFetchingVerificationStatusGraph(false);
            }

        }).catch((error) => {
            console.log("getVerificationStatusGraph error xxxx", error);

            setVerificationStatusGraph([]);
            setFetchingVerificationStatusGraph(false);
        })
    }

    const getDashboardVerificationOverview = () => {
        setFetchDashboardOverview(true);

        DashboardService.getDashboardVerificationOverview().then((res) => {
            console.log("getDashboardVerificationOverview data xxxx", res.data);
            
            if (res.data.success) {
                setDashboardOverviewCount(res.data.data);
                setFetchDashboardOverview(false);
            }

        }).catch((error) => {
            console.log("getDashboardVerificationOverview error xxxx", error);

            setDashboardOverviewCount();
            setFetchDashboardOverview(false);
        })
    }


    return {isFetchingTotalSuccessfulVerification, totalSuccessfulVerificationCount, verificationCountStatusDateRange, 
        verificationCount, topVerificationProducts, authenticationOverviewCount, authenticationStatus, authenticationCount, 
        totalAuthenticationPerHour, topProductAnomalies, topProductAnomalyDetection, geolocationDistributionData,
        getTotalVerification, getTotalVerificationByDateRange, getVerificationCount, getTopVerificationProducts, 
        getDashboardTotalAuthenticationByStatus, getDashboardAuthenticationStatus, getDashboardAuthenticationCount,
        getTotalAuthenticationPerHour, getTopProductAnomalies, getProductAnomalyDetection, getGeolocationDistribution,
        totalVerificationPerHour, getTotalVerificationPerHour, getTotalVerificationStatusGraphByDateRange, verificationStatusGraphDateRange,
        isFetchingVerificationStatus, isFetchingTopProductsAnomalies, isFetchingVerificationCount, isFetchingDashboardAuthenticationStatus,
        isFetchingDashboardAuthenticationCount, isFetchingAnomalyDetection, isFetchingTopVerificationProducts, isFetchingGeographicDistribution,
        isFetchPeakVerificationTimeAnalysis, getGeolocationDistributionFilterByCountry, getVerificationStatusGraph, verificationStatusGraph,
        isFetchingVerificationStatusGraph, dashboardOverviewCount, isFetchDashboardOverview, getDashboardVerificationOverview, 
    }
}

export default useDashboard